// index.ts
import { booleanDisjoint } from "@turf/boolean-disjoint";
import { flattenEach } from "@turf/meta";
function booleanIntersects(feature1, feature2) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _a;
    var ignoreSelfIntersections = (_a = options.ignoreSelfIntersections) != null ? _a : false;
    var bool = false;
    flattenEach(feature1, function(flatten1) {
        flattenEach(feature2, function(flatten2) {
            if (bool === true) {
                return true;
            }
            bool = !booleanDisjoint(flatten1.geometry, flatten2.geometry, {
                ignoreSelfIntersections: ignoreSelfIntersections
            });
        });
    });
    return bool;
}
var turf_boolean_intersects_default = booleanIntersects;
export { booleanIntersects, turf_boolean_intersects_default as default }; //# sourceMappingURL=index.js.map
